"use strict";
'use es6';

require("../moment/moment-and-timezone-init");

require("moment-timezone/static-5.10/builds/moment-timezone-with-data-2005-2020");